export const colors = {
  BLUE: "#2c2c54",
  CREAM: "#f5d6ba",
  RED: "#a40e4c",
  LIGHTER_RED: "#d66593",
  GREY: "#cfd8dc",
  DARKER_GREY: "#90a4ae",
}
